module.exports = __webpack_public_path__ + "img/IMG_6984_L.e010f098.webp";